export * as badges from '@wix/auto_sdk_members_badges/meta';
export * as badgesV2 from '@wix/auto_sdk_members_badges-v-2/meta';
export * as badgeAssignments from '@wix/auto_sdk_members_badge-assignments/meta';
export * as authentication from '@wix/auto_sdk_members_authentication/meta';
export * as membersAbout from '@wix/auto_sdk_members_members-about/meta';
export * as userMember from '@wix/auto_sdk_members_user-member/meta';
export * as customFields from '@wix/auto_sdk_members_custom-fields/meta';
export * as customFieldApplications from '@wix/auto_sdk_members_custom-field-applications/meta';
export * as customFieldSuggestions from '@wix/auto_sdk_members_custom-field-suggestions/meta';
export * as defaultPrivacy from '@wix/auto_sdk_members_default-privacy/meta';
export * as members from '@wix/auto_sdk_members_members/meta';
export * as memberPrivacySettings from '@wix/auto_sdk_members_member-privacy-settings/meta';
export * as memberReport from '@wix/auto_sdk_members_member-report/meta';
export * as memberRoleDefinition from '@wix/auto_sdk_members_member-role-definition/meta';
export * as memberToMemberBlock from '@wix/auto_sdk_members_member-to-member-block/meta';
export * as authorization from '@wix/auto_sdk_members_authorization/meta';
export * as memberFollowers from '@wix/auto_sdk_members_member-followers/meta';
